import { Routes } from "@angular/router";

import { budgetGuard } from "@core/guards/budget/budget.guard";
import { checkoutDataGuard } from "@modules/checkout/guards/checkout-data.guard";

export const routes: Routes = [
  {
    path: "",
    data: {
      pagePath: "/redirect-stores",
    },
    loadComponent: () =>
      import("@modules/home/home-page.component").then((m) => m.HomePageComponent),
  },
  {
    path: "orcamentos/:id",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./app/modules/budgets/budget-auth/budget-auth.component").then(
            (m) => m.BudgetAuthComponent,
          ),
      },
      {
        path: "detalhes",
        loadComponent: () =>
          import("./app/modules/budgets/budget-show/budget-show.component").then(
            (m) => m.BudgetShowComponent,
          ),
        canActivate: [budgetGuard],
      },
    ],
  },
  {
    path: "checkout/:id",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("@modules/checkout/checkout.component").then((m) => m.CheckoutComponent),
        data: {
          skipSendPageView: true,
        },
      },
      {
        path: "cartao-credito",
        canActivate: [checkoutDataGuard],
        loadComponent: () =>
          import("@modules/checkout/modules/credit-card/credit-card.component").then(
            (m) => m.CreditCardComponent,
          ),
      },
      {
        path: "pix",
        canActivate: [checkoutDataGuard],
        loadComponent: () =>
          import("@modules/checkout/modules/pix/pix.component").then((m) => m.PixComponent),
      },
      {
        path: "pagamento-efetuado",
        canActivate: [checkoutDataGuard],
        loadComponent: () =>
          import("@modules/checkout/modules/payment-success/payment-success.component").then(
            (m) => m.PaymentSuccessComponent,
          ),
      },
    ],
  },
  {
    path: "erro",
    loadComponent: () =>
      import("@modules/error/error-page.component").then((m) => m.ErrorPageComponent),
  },

  // Non handled routes
  {
    path: "**",
    redirectTo: "/",
  },
];
